/*-----------------------------------------------------------------
- Auth translations
-----------------------------------------------------------------*/

export default {
    login: {
        title          : 'Log in',
        subtitle       : 'Welcome back! Please Enter Your Details.',
        email          : 'Your Email',
        password       : 'Your Password',
        btn_code       : 'Log in',
        remember_me    : 'Remember Me',
        enter_user_name: 'Please',
        enter_password : 'Please Enter Your Password.',
        button         : 'Log in',
        sign_up_now    : 'أفتح حساب الأن',
        auth_toggle    : {
            description: 'Don’t Have an Account? ',
            link       : 'Sign Up',
        },
        forget_link: 'Forget Your Password?',
    },
    register: {
        title      : 'Sign Up',
        subtitle   : 'Let’s Level Up Your Brand, together.',
        button     : 'Get Started',
        password   : 'Your Password',
        email      : 'Your Email',
        auth_toggle: {
            description: 'Already Have an Account? ',
            link       : 'Log in',
        },
    },
    forget: {
        forget_request: {
            title    : 'Reset password',
            subtitle : 'Enter the email associated with your account and we\'ll email you some instructions to reset your password.',
            send_code: 'Reset Password',
            email    : 'Your Email',
        },
        verify_token: {
            title            : 'Confirm Code',
            subtitle         : 'Enter The 6-digit code We Sent To ',
            code_was_not_sent: 'Didn\'t receive a Code ',
            reset_password   : 'Reset Password',
            edit_email       : 'Edit Email',
            resend_code      : 'Resend Code',
            token            : {
                text  : 'Didn\'t Receive a Code?',
                resend: 'Resend Code',
            },
        },
        reset_password: {
            title        : 'Reset Password',
            subtitle     : 'Your New Password Must be Different from Previous used Password ',
            new_password : 'New Password',
            new_password2: 'Confirm Password',
            submit       : 'Reset Password',
        },

        messages: {
            success_reset: 'Account Password has been changed Successfully! ',
        },
    },

};
